export function getAgencyDisplayName(
  profile?: { agency_name?: string | null } | string | null,
) {
  if (typeof profile === "string") {
    return profile || "مشاور";
  }

  return profile?.agency_name ?? "مشاور";
}
